import { Flex } from "src/elements";
import styled from "styled-components";

const grillPatternUrl = `${import.meta.env.BASE_URL}grill-pattern.svg`;

const GrillContainer = styled(Flex)<{
  grillHeight: number;
  scaleY: number;
}>`
  width: 100%;
  height: ${({ grillHeight, scaleY }) => `calc(${grillHeight}px * ${scaleY})`};
  position: absolute;
  top: ${({ grillHeight, scaleY }) => `calc(${grillHeight}px * -${scaleY})`};
  left: 0;
  z-index: 1;
  pointer-events: none;
`;

const GrillElement = styled(Flex)`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  background-image: url(${grillPatternUrl});
  background-repeat: repeat;
  background-size: 8px 8px;
`;

interface Props {
  height: number;
  scaleY: number;
}

export const Grill = ({ height, scaleY }: Props) => {
  if (height === 0) return null;

  return (
    <GrillContainer grillHeight={height} scaleY={scaleY}>
      <GrillElement />
    </GrillContainer>
  );
};
